import axios from "axios";
import { HOST_URL } from "./Host";

export const SET_FORMALITY_REQUEST = "SET_FORMALITY_REQUEST";

const headers = {
  Accept: "application/json",
  "X-Accept-Version": "2.0",
};

export function setFormalityRequest(request) {
  return {
    type: SET_FORMALITY_REQUEST,
    payload: request,
  };
}

export function createCrimRecordRequest(token, requestData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `${HOST_URL}/requests/criminal-record`,
        requestData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await dispatch(setFormalityRequest(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function uploadCrimRecordDocuments(
  token,
  reference,
  formData,
  callback
) {
  return async () => {
    try {
      const res = await axios.post(
        `${HOST_URL}/requests/criminal-record/${reference}/upload`,
        formData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      callback({ success: true, message: res.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function createCertificateNationalityRequest(
  token,
  requestData,
  callback
) {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `${HOST_URL}/requests/nationality-certificate`,
        requestData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await dispatch(setFormalityRequest(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function uploadCertificateNationalityDocuments(
  token,
  reference,
  formData,
  callback
) {
  return async () => {
    try {
      const res = await axios.post(
        `${HOST_URL}/requests/nationality-certificate/${reference}/upload`,
        formData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      callback({ success: true, message: res.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function createCertificateSinglenessRequest(
  token,
  requestData,
  callback
) {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `${HOST_URL}/requests/celibacy-certificate`,
        requestData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await dispatch(setFormalityRequest(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function uploadCertificateSinglenessDocuments(
  token,
  reference,
  formData,
  callback
) {
  return async () => {
    try {
      const res = await axios.post(
        `${HOST_URL}/requests/celibacy-certificate/${reference}/upload`,
        formData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      callback({ success: true, message: res.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function eneoRequest(token, requestData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `${HOST_URL}/requests/eneo`,
        requestData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await dispatch(setFormalityRequest(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function eneoDocuments(token, reference, formData, callback) {
  return async () => {
    try {
      const res = await axios.post(
        `${HOST_URL}/requests/eneo/${reference}/upload`,
        formData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      callback({ success: true, message: res.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function createCustomsRebateRequest(token, requestData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `${HOST_URL}/requests/customs-rebate`,
        requestData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await dispatch(setFormalityRequest(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function uploadCustomsRebateDocuments(
  token,
  reference,
  formData,
  callback
) {
  return async () => {
    try {
      const res = await axios.post(
        `${HOST_URL}/requests/customs-rebate/${reference}/upload`,
        formData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      callback({ success: true, message: res.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function createBusinessPlanRequest(token, requestData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `${HOST_URL}/requests/business-plan`,
        requestData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await dispatch(setFormalityRequest(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function uploadBusinessPlanDocuments(
  token,
  reference,
  formData,
  callback
) {
  return async () => {
    try {
      const res = await axios.post(
        `${HOST_URL}/requests/business-plan/${reference}/upload`,
        formData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      callback({ success: true, message: res.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function createImportationRequest(token, requestData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `${HOST_URL}/requests/importation`,
        requestData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await dispatch(setFormalityRequest(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function getImportationRequests(token, company, callback) {
  return async () => {
    try {
      const response = await axios.get(
        `${HOST_URL}/requests/importation?company=${company}`,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await callback(response.data.data);
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function uploadImportationDocuments(
  token,
  reference,
  formData,
  callback
) {
  return async () => {
    try {
      const res = await axios.post(
        `${HOST_URL}/requests/importation/${reference}/upload`,
        formData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      callback({ success: true, message: res.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function createOapiRequest(token, requestData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `${HOST_URL}/requests/oapi`,
        requestData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await dispatch(setFormalityRequest(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function getOapiRequests(token, company, callback) {
  return async () => {
    try {
      const response = await axios.get(
        `${HOST_URL}/requests/oapi?company=${company}`,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await callback(response.data.data);
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function uploadOapiDocuments(token, reference, formData, callback) {
  return async () => {
    try {
      const res = await axios.post(
        `${HOST_URL}/requests/oapi/${reference}/upload`,
        formData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      callback({ success: true, message: res.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function createPassportRequest(token, requestData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `${HOST_URL}/requests/passport-enrollment`,
        requestData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await dispatch(setFormalityRequest(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function updatePassportRequest(token, reference, requestData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.put(
        `${HOST_URL}/requests/passport-enrollment/${reference}`,
        requestData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await dispatch(setFormalityRequest(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function createVisualIdentityRequest(token, requestData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `${HOST_URL}/requests/visual-identity`,
        requestData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        },
      );
      await dispatch(setFormalityRequest(response.data.data));
      callback({
        success: true,
        message: response.data.message,
        data: response.data.data,
      });
    } catch (error) {
      callback({
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Une erreur inattendue est survenue.",
      });
    }
  };
}

export function uploadVisualIdentityLogo(token, reference, formData, callback) {
  return async () => {
    try {
      const res = await axios.post(
        `${HOST_URL}/requests/visual-identity/${reference}/upload`,
        formData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      callback({ success: true, message: res.data.message });
    } catch (error) {
      callback({
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Une erreur inattendue est survenue.",
      });
    }
  };
}

const errorMessage = (error) =>
  error.response?.data?.message ||
  error.message ||
  "Une erreur inattendue est survenue.";

// Creates a request and keeps it as the current formality request
const postRequest = (path, token, requestData, callback) => async (dispatch) => {
  try {
    const response = await axios.post(`${HOST_URL}${path}`, requestData, {
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
      },
    });
    await dispatch(setFormalityRequest(response.data.data));
    callback({
      success: true,
      message: response.data.message,
      data: response.data.data,
    });
  } catch (error) {
    callback({ success: false, message: errorMessage(error) });
  }
};

const postDocuments = (path, token, formData, callback) => async () => {
  try {
    const response = await axios.post(`${HOST_URL}${path}`, formData, {
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    callback({ success: true, message: response.data.message });
  } catch (error) {
    callback({ success: false, message: errorMessage(error) });
  }
};

export function createTrademarkRequest(token, requestData, callback) {
  return postRequest("/requests/trademark", token, requestData, callback);
}

export function uploadTrademarkDocuments(token, reference, formData, callback) {
  return postDocuments(
    `/requests/trademark/${reference}/upload`,
    token,
    formData,
    callback,
  );
}

export function createTaxRegistrationRequest(token, requestData, callback) {
  return postRequest(
    "/requests/tax-registration",
    token,
    requestData,
    callback,
  );
}

export function uploadTaxRegistrationDocuments(
  token,
  reference,
  formData,
  callback,
) {
  return postDocuments(
    `/requests/tax-registration/${reference}/upload`,
    token,
    formData,
    callback,
  );
}

export function createTaxComplianceRequest(token, requestData, callback) {
  return postRequest("/requests/tax-compliance", token, requestData, callback);
}

export function createCnpsRegistrationRequest(token, requestData, callback) {
  return postRequest(
    "/requests/cnps-registration",
    token,
    requestData,
    callback,
  );
}

export function uploadCnpsRegistrationDocuments(
  token,
  reference,
  formData,
  callback,
) {
  return postDocuments(
    `/requests/cnps-registration/${reference}/upload`,
    token,
    formData,
    callback,
  );
}
